var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Base } from "./base";
var Overlay = /** @class */ (function (_super) {
    __extends(Overlay, _super);
    function Overlay() {
        var _this = _super.call(this) || this;
        var overlay = document.createElement('div');
        overlay.id = 'js_aigo_bot_overlay';
        overlay.style.zIndex = '2147483647';
        _this.self = overlay;
        return _this;
    }
    Overlay.prototype.hide = function () {
        this.self.style.backgroundColor = '';
        this.self.style.position = '';
        this.self.style.left = '';
        this.self.style.top = '';
        this.self.style.width = '';
        this.self.style.height = '';
    };
    Overlay.prototype.show = function () {
        this.self.style.backgroundColor = 'rgba(0,0,0,0.3)';
        this.self.style.position = 'fixed';
        this.self.style.left = '0';
        this.self.style.top = '0';
        this.self.style.width = '100%';
        this.self.style.height = '100%';
    };
    return Overlay;
}(Base));
export { Overlay };
